document.addEventListener('DOMContentLoaded', () => {
	// slick default setting
	let defaultsettings = {
		loop: true,
		speed: 700,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		navigation: {
			nextEl: '.swiper-prev',
			prevEl: '.swiper-next',
		},
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
	}

	// start slider default
	let allSwipper = []

	document.querySelectorAll('.swiper-slider').forEach((element, i) => {
		let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaultsettings;
		element.setAttribute(`data-swiper-${i}`, '');
		let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
		allSwipper[i] = swiper;
	})

	allSwipper.forEach((swiper) => {
		const customControl = swiper.passedParams.customcontrol;
		if (customControl) {
				const targetIds = customControl.substr(1).split(" ");
				const targetSwipers = allSwipper.filter((s) => targetIds.includes(s.el.id));
				if (targetSwipers.length > 0) {
						swiper.controller.control = targetSwipers;
				}
		}
	});

	document.querySelectorAll('[data-swiper-goto]').forEach((item) => {
		const target = item.dataset.swiperGoto ? parseInt(item.dataset.swiperGoto) : 0
		const slider = item.dataset.swipertarget ? document.querySelector(item.dataset.swipertarget) : item.closest('.swiper-slider')
		item.addEventListener('click', (e) => {
			slider.swiper.slideTo(target)
			document.querySelectorAll(`[data-swiper-goto]`).forEach((itm) => itm.classList.remove('active'))
			item.classList.add('active')
		})
	})

	if (document.querySelector('.gallery-block') != null) {
		let gallery_left = new Swiper(`.gallery-swiper-left`, {
			loop: true,
			speed: 700,
			allowTouchMove: false,
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			}
		})

		let gallery_middle = new Swiper(`.gallery-swiper-middle`, {
			loop: true,
			speed: 700,
			navigation: {
				nextEl: '[data-gallerynext]',
				prevEl: '[data-galleryprev]',
			},
			pagination: {
				el: '[data-gallerydots]',
				clickable: true,
			},
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			}	
		})

		let gallery_right = new Swiper(`.gallery-swiper-right`, {
			loop: true,
			speed: 700,
			allowTouchMove: false,
			effect: 'fade',
			fadeEffect: {
			crossFade: true,
			}
		})

		if (window.innerWidth >= 700) {
			gallery_middle.controller.control = [gallery_right, gallery_left]
		}
	}

})
